import {MenuToggle} from './elements/menu-toggle'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const $mainMenu = $('.main-menu')
const menuToggleBtn = $('.menu-toggle-btn')
const menuToggleTitle = $('.menu-toggle-btn .menu-toggle-title')
const menuToggle = new MenuToggle('.menu-toggle-btn')

// Function to set the active menu item based on the current URL
function setActiveMenuItem() {
  const currentPath = window.location.pathname; // Get the current path
  $('.main-menu a').each(function () {
    const $link = $(this);
    const linkPath = $link.attr('href');

    // Check if the href matches the current URL path and add the 'active' class
    if (linkPath && currentPath.includes(linkPath)) {
      $link.addClass('active');
    }
  });
}

document.addEventListener('DOMContentLoaded', setActiveMenuItem); // Run the function when the document is ready


document.addEventListener("toggleMenu", function (e) {
  if (e.detail && e.detail.showMenu) {
    menuToggleTitle.text(menuToggleBtn.attr('data-title-opened'))
    $mainMenu.addClass('is-mobile-open')
  } else {
    menuToggleTitle.text(menuToggleBtn.attr('data-title-closed'))
    $mainMenu.removeClass('is-mobile-open')
  }
})

import {getSmoothScroll} from './scroll-smoother'
import {breakpointDown, breakpointUp} from './utils/breakpoints'

const $body = $('body')
$body.on('click', '[data-nav-scroll]', function (e) {
  e.preventDefault()

  if ($mainMenu.hasClass('is-mobile-open')) {
    menuToggle.closeButton();
  }

  const hash = $(this).attr('data-nav-scroll')

  if (!hash || !hash.length) return false

  if (!$('[data-nav-id="' + hash + '"]').length) return false

  const smoothScroll = getSmoothScroll()

  console.log(smoothScroll, hash)

  smoothScroll.scrollTo('[data-nav-id="' + hash + '"]', true)

})


$body.on('click', '[data-nav-scroll-pos]', function (e) {
  e.preventDefault()

  let to = $(this).attr('data-nav-scroll-pos')

  const smoothScroll = getSmoothScroll()
  smoothScroll.scrollTo(to, true)


})

$body.on('click', '.to-the-top', function (e) {
  e.preventDefault()

  const smoothScroll = getSmoothScroll()
  smoothScroll.scrollTo(0, true)
})

$body.on('click', '.js--dropdown-trigger', function (e) {
  $('.js--mobile-menu-dropdown').toggleClass('dropdown-open');
  $('.js--mobile-menu-dropdown').find('.list').toggleClass('open')
})

$(document).on('click', function(event) {
  if (!$(event.target).closest('.js--mobile-menu-dropdown').length) {
    $('.js--mobile-menu-dropdown').removeClass('dropdown-open');
    $('.js--mobile-menu-dropdown').find('.list').removeClass('open')

  }
});

document.addEventListener("DOMContentLoaded", function() {
  const currentUrl = window.location.href;
  const menuLinks = document.querySelectorAll('.menu-links-list a');

  menuLinks.forEach(link => {
    if (link.href === currentUrl) {
      link.classList.add('active');
    }
  });
});


